import axios from "axios";
export default {
    data() {
        return {
            token: null,
            subscribedTopics: null,
            subscribedTopicsOriginal:null
        }
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("token");
        if (token) {
            localStorage.setItem("uuid", token);
            this.token = token;
        } else {
            this.token = localStorage.getItem("uuid");
        }

        if (this.token) {
            this.fetchKeywords();
        }

        this.sendTracking(this.getOrCreateVisitorId());
    },
    computed: {
        hasSubscribedTopics(){
            return this.subscribedTopics && Object.keys(this.subscribedTopics).length>0;
        },
        isLoadingSubscribedTopics(){
            return null==this.subscribedTopics;
        },
        hasLogin(){
            return this.token!=null;
        },
        supportShareApi(){
            return navigator && navigator.share;
        },
        isMobileDevice() {
            if (navigator.userAgentData) {
              // Mit userAgentData arbeiten, wenn verfügbar
              const uaData = navigator.userAgentData;
              return uaData.mobile;  // Gibt `true` zurück, wenn es sich um ein mobiles Gerät handelt
            } else {
              // Fallback auf ältere Methode für ältere Browser
              return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
            }
        }
          
    },
    methods: {
        getOrCreateVisitorId() {
            try {
              const storageKey = "visitor_id";
              const today = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD
              
              const storedData = localStorage.getItem(storageKey);
              if (storedData) {
                const { date, visitorId } = JSON.parse(storedData);
                if (date === today && visitorId) {
                  return visitorId; // Return existing ID if it's from today
                }
              }
              
              // Generate a new UUID for the visitor
              const newVisitorId = this.generateUUID();
              localStorage.setItem(storageKey, JSON.stringify({ date: today, visitorId: newVisitorId }));
              
              return newVisitorId;
            } catch (error) {
              return null;
            }
        },
        generateUUID() {
            // Use crypto.randomUUID if available
            if (crypto && crypto.randomUUID) {
                return crypto.randomUUID();
            }
        
            // Fallback to a polyfill for generating UUID
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
                const r = (Math.random() * 16) | 0;
                const v = c === "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },
        async registerUser(email, fctSuccess) {
            if (this.isValidEmail(email)) {
                try {
                    const response = await fetch(
                        `/access.php?action=register&email=${encodeURIComponent(email)}&format=json`
                    );
                    if (response.ok) {
                        return { success: true };
                    } else {
                        console.error("Fehler beim Registrieren", response);
                        return { success: false };
                    }
                } catch (error) {
                    console.error("Netzwerkfehler:", error);
                    return { success: false, error };
                } finally {
                    if (typeof (fctSuccess) == "function") {
                        fctSuccess();
                    }
                }
            } else {
                return { success: false, error: "E-Mail-Adresse ist leer." };
            }
        },

        async fetchKeywords(fctSuccess) {
            try {
                const response = await fetch(
                    `/notify.php?action=get&token=${this.token}&format=json&raw=true`
                );
                const data = await response.json();
                if (data.success) {
                    this.subscribedTopics=data.result;
                    return { success: true, keywords: data.result };
                } else {
                    console.error("Fehler beim Abrufen der Daten:", data);
                    return { success: false };
                }
            } catch (error) {
                console.error("Netzwerkfehler:", error);
                return { success: false, error };
            } finally {
                if (typeof (fctSuccess) == "function") {
                    fctSuccess();
                }
            }
        },

        async subscribe(mail, token, searchKey,exact, fctSuccess) {
            if (mail || token) {

                let url = `/notify.php?action=subscribe&email=${mail}&format=json&exact=${exact}&search=${encodeURIComponent(searchKey)}`;
                if (null != token) {
                    url += `&token=${token}`;
                }
                try {
                    const response = await axios.get(url);

                    let data = response.data || {};
                    if (data.token) {
                        localStorage.setItem("uuid", data.token);
                        this.token = data.token;
                    }

                    return true;

                } catch (error) {
                    console.error("Fehler beim Abrufen der Daten:", error);
                } finally {
                    //Add keyword
                    if(this.subscribedTopics){
                        this.addNewTopic(searchKey,exact);
                      }
                    if (typeof (fctSuccess) == "function") {
                        fctSuccess();
                    }
                }
            }
            return false;
        },

        async unsubscribe(uuid, keyword, fctSuccess) {
            try {
                const response = await fetch(
                    `/notify.php?action=unsubscribe&token=${uuid}&format=json&search=${encodeURIComponent(keyword)}`
                );
                if (response.ok) {
                    return { success: true };
                } else {
                    console.error("Fehler beim Entfernen des Keywords", response);
                    return { success: false };
                }
            } catch (error) {
                console.error("Netzwerkfehler:", error);
                return { success: false, error };
            } finally {
                //Remove keyword
                this.removeTopic(keyword);
                if (typeof (fctSuccess) == "function") {
                    fctSuccess();
                }
            }
        },

        async deleteAll(fctSuccess) {
            try {
                const response = await fetch(
                    `/access.php?action=register&token=${this.token}&format=json`
                );
                if (response.ok) {
                    localStorage.clear();
                    this.token = null;
                    this.subscribedTopics=null;
                    return { success: true };
                } else {
                    console.error("Fehler beim Löschen des Nutzers", response);
                    return { success: false };
                }
            } catch (error) {
                console.error("Netzwerkfehler:", error);
                return { success: false, error };
            }finally{
                if (typeof (fctSuccess) == "function") {
                    fctSuccess();
                }
            }
        },
        async sendTracking(visitorId) {
            if (!visitorId || !visitorId.trim()) {
                console.error("Invalid Visitor ID");
                return;
            }

            try {
                const url = "/visitor.php";
                const payload = { visitor_id: visitorId };
                await axios.post(url, payload);

            } catch (error) {
                console.error("Error while sending data:", error);
            }
        },
        async search(searchKey, exactSearch, fctSuccess) {
            if (!searchKey || searchKey.trim().length < 1){
                fctSuccess();
                return;
            }

            const url = '/search.php'+this.getSearchParams(searchKey, exactSearch)+'&format=json&limit=15';
            try {
                const response = await axios.get(url);
                this.results = response.data || {};
            } catch (error) {
                console.error("Fehler beim Abrufen der Daten:", error);
            } finally {
                if (typeof (fctSuccess) == "function") {
                    fctSuccess();
                }
            }
        },
        async share(title,text,url) {
            if (navigator.share) {
                try {
                await navigator.share({
                    title: title,
                    text: text,
                    url: url
                });
                } catch (error) {
                    console.warn('Teilen abgebrochen oder fehlgeschlagen', error);
                }
            }
        },
        getSearchParams(searchKey, exactSearch){
            return `?search=${encodeURIComponent(
                searchKey
            )}&exact=${exactSearch}`;
        },
        isValidEmail(email) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        },
        addNewTopic(newKey, newValue) {
            if(this.subscribedTopics){
                this.subscribedTopics[newKey] = { exact: newValue };
                return this.subscribedTopics;
            }
        },
        removeTopic(keyword){
            if(this.subscribedTopics){
                this.$delete(this.subscribedTopics, keyword);
            }
        }
    }
};
